import {
  GET_LOCATION_MATCHES_BY_REQUEST_DATA_CLEAR,
  GET_LOCATION_MATCHES_BY_REQUEST_DATA_FAILURE,
  GET_LOCATION_MATCHES_BY_REQUEST_DATA_REQUEST,
  GET_LOCATION_MATCHES_BY_REQUEST_DATA_SUCCESS,
  GetLocationMatchesByRequestActionTypes,
  GetLocationMatchesByRequestState
} from "store/reducers/lodgingOption/get-location-matches-by-request/types";

const defaultState: GetLocationMatchesByRequestState = {
  isLoading: false,
  errorMessage: ""
};

export default function getLocationMatchesByRequest(state = defaultState, action: GetLocationMatchesByRequestActionTypes): GetLocationMatchesByRequestState {
  switch (action.type) {
    case GET_LOCATION_MATCHES_BY_REQUEST_DATA_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case GET_LOCATION_MATCHES_BY_REQUEST_DATA_SUCCESS:
      return {
        ...state,
        contents: action.contents,
        isLoading: false,
        errorMessage: ""
      };
    case GET_LOCATION_MATCHES_BY_REQUEST_DATA_FAILURE:
      return {
        ...state,
        isLoading: false,
        errorMessage: ""
      };
    case GET_LOCATION_MATCHES_BY_REQUEST_DATA_CLEAR:
      return {
        ...state,
        contents: {
          rows: [],
          rowsCount: 0,
          hasMore: false,
        },
        isLoading: false,
        errorMessage: ""
      };
    default:
      return state;
  }
};